import React from "react";
var PaginationProgressBar = React.memo(function (_a) {
    var progress = _a.progress;
    return (
    // <div className="w-full h-2 bg-gray-700 rounded">
    //   <div
    //     className="h-2 bg-green-500 rounded transition-all duration-100"
    //     style={{ width: `${progress}%` }}
    //   />
    // </div>
    React.createElement("div", { className: "w-full", style: { height: "0.1rem", backgroundColor: "#374151" } },
        React.createElement("div", { className: "h-full bg-blue-500 transition-all", style: { width: "".concat(progress, "%") } })));
});
export default PaginationProgressBar;
